import Gnavi from './Gnavi';
import LocalNavi from './LocalNavi';
import Submenu from './Submenu';
import LinkGroups from './LinkGroups';
import LinkGroup from './LinkGroup';
import NavigationPaging from './NavigationPaging';
import PanelLinkGroup from './PanelLinkGroup';
import NavigationTags from './NavigationTags';
import NavigationTag from './NavigationTag';
import NavigationInfo from './NavigationInfo';

export default {
  Gnavi,
  LocalNavi,
  Submenu,
  LinkGroups,
  LinkGroup,
  NavigationPaging,
  PanelLinkGroup,
  NavigationTags,
  NavigationTag,
  NavigationInfo,
}



// WEBPACK FOOTER //
// ./src/js/ui/components/navigations/index.js